// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"62844900","225":"fd4e4d98","481":"da867efe","496":"8cba8f92","560":"c1a71d23","625":"fd24f76d","710":"ec1551aa","760":"aebbfcb4"}[chunkId] + ".chunk.js";
};